export default [
  {
    component: () => import("@/components/public/ViewPublicCandidatura.vue"),
    meta: { isPublic: true },
    name: "public.candidatura",
    path: "/candidatura/:token",
  },
  {
    component: () => import("@/components/produtividade/gantt/ViewGanttCompartilhado.vue"),
    meta: { isPublic: true },
    name: "public.gantt.compartilhado",
    path: "/gantt/compartilhado/:token",
  },
  {
    component: () => import("@/components/public/ViewGaleriaComponentes.vue"),
    meta: { isPublic: true },
    name: "public.galeria-componentes",
    path: "/ui/componentes",
  },
  {
    component: () => import("@/components/webponto/ViewWebPonto.vue"),
    meta: { isPublic: true },
    name: "webponto",
    path: "/webponto",
  },
  {
    component: () => import("@/components/faturamento/configuracoes/templates/editor-template-externo.vue"),
    meta: { isPublic: true },
    name: "externo.templates.cadastro",
    path: "/externo/templates/:token",
  },
];
